import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentNetwork } from '@/redux/slices/session'

export function useCurrentNetwork() {
  return useAppSelector(selectCurrentNetwork)
}
